import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"

export const GenericErrorPage = () => {
  const { t } = useTranslation()
  return (
    <div className="h-full min-h-screen grid grid-cols-12">
      <div className="flex flex-col justify-center col-start-2 col-end-12 md:col-start-4 md:col-end-10">
        <div className="flex flex-col md:border md:border-greyLighter md:p-10 md:rounded">
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className="text-janeBlue h-10 pb-4"
          />
          <h1 className="text-3xl font-light text-center">
            {t("error.somethingWentWrong")}
          </h1>
          <p className="mt-2 text-greyDark text-center ">
            {t("error.oopsThereWasAProblem")}
          </p>
          <button
            className="p-4 mt-4 text-white bg-janeBlue rounded text-lg "
            onClick={() => window.location.reload()}
          >
            {t("error.tryAgain")}
          </button>
        </div>
      </div>
    </div>
  )
}
